<template>
    <div class="views-content--usecase">
        <banner-study :data="data.hero" :class="addedClassZero"></banner-study>

        <!-- elements -->
        <div v-for="(element, index) in data.elements" :key="element.id">
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>
    </div>
</template>

<script>
    import viewsElementClasses from '../mixins/viewsElementClasses';
    import { BannerStudy } from "../components";

    // elements
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";

    export default {
        name: "v-use-case",
        mixins: [viewsElementClasses],
        components: {
            BannerStudy,
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage,
            ElementForm
        },
        props: {
            data: {
                type: Object
            }
        }
    };
</script>

